(() => {
  const form = document.querySelector('#jb-wardrobe #inquiry');
  const button = form.querySelector('button[type="submit"]');
  const status = document.querySelector('#jb-wardrobe #inquiry-status');
  const enabled = true;
  const choices = {
    shopping: {like:'I like to shop.', hate:'I hate to shop.', time:'I don’t mind, but finding the time is difficult.'},
    fit: {yes:'Yes, I have pieces that fit well.', some:'Some pieces fit well, but others need attention.', challenge:'Finding the right fit has been a challenge.'},
    meeting: {showroom:'At the Jeffrey Bartlett Clothiers showroom.', home:'At my home.', either:'I’m open to either.'}
  };
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (!enabled || button.disabled || !form.reportValidity()) return;
    const data = new FormData(form);
    const name = String(data.get('name') || '').trim().split(/\s+/);
    const fields = [
      {name:'firstname', value:name.shift() || ''},
      {name:'lastname', value:name.join(' ')},
      {name:'email', value:String(data.get('email') || '').trim()}
    ];
    const phone = String(data.get('phone') || '').trim();
    if (phone) fields.push({name:'phone',value:phone});
    for (const [key, property] of Object.entries({shopping:'wardrobe_shopping_preference',fit:'wardrobe_fit_experience',meeting:'wardrobe_meeting_preference'})) {
      const value = choices[key][data.get(key)];
      if (value) fields.push({name:property,value});
    }
    button.disabled = true;
    button.textContent = 'Sending…';
    status.textContent = '';
    try {
      const response = await fetch('https://api.hsforms.com/submissions/v3/integration/submit/244134179/385a6347-d025-480a-a954-e154a7291a01', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({fields:fields.map(field => ({objectTypeId:'0-1',...field})),context:{pageName:'Wardrobe Planning | Jeffrey Bartlett Clothiers',pageUri:location.origin + location.pathname}}),
        signal:AbortSignal.timeout(20000)
      });
      if (!response.ok) throw new Error('Submission failed');
      form.reset();
      status.textContent = 'Thank you. We’ll contact you to discuss your wardrobe and arrange a convenient time to meet.';
      button.textContent = 'Inquiry received';
    } catch (error) {
      status.textContent = 'We couldn’t confirm your inquiry was received. Please try again or email mariah@jeffreybartlett.com.';
      button.disabled = false;
      button.textContent = 'Request a Private Consultation';
    }
  });
})();
